import { topicsItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 border border-accent-200/60 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-hashtag text-sm"></i>
            热门话题
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">大家都在聊什么</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">当前最火热的吃瓜话题标签，点击探索更多相关内容。</p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {topicsItems.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-500 border-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-500'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-sm"></i>}
              <span>{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-background-50/70' : 'text-foreground-400'}`}>{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}